module.exports = __webpack_public_path__ + "img/Logo-Berget-21.6be7a31e.png";